import { Button, Icon, Timeline } from 'antd'
import React from 'react'

function DeliveryRouteList(props) {
  const { list, isUpdatable, isConfirmed, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'No',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <a disabled={isConfirmed} onClick={() => onShow(original, 'edit')}>
          {value}
        </a>
      ),
    },
    { Header: 'Start Stop', accessor: 'start.location.address.label' },
    { Header: 'End Stop', accessor: 'end.location.address.label' },
  ]

  function TimelineItem({ status, text }) {
    let icon
    switch (status) {
      case 'delivered':
        icon = 'clock-circle-o'
        break
      case 'inRoute':
        icon = 'clock-circle-o'
        break
      case 'pending':
        icon = 'clock-circle-o'
        break
    }
    return (
      <Timeline.Item dot={<Icon type={icon} style={{ fontSize: '16px' }} />} color="red">
        {text}
      </Timeline.Item>
    )
  }

  console.log(43, isUpdatable)
  return (
    <>
      <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={!isUpdatable}>
        New Route
      </Button>
      <Timeline style={{ margin: '3em 8em', width: '100hv' }}>
        {list.map(route => {
          console.log({ route })
          const fromLocation = route.start.location
          const fromLabel = `${fromLocation.country},${fromLocation.location} `
          const toLocation = route.end.location
          const toLabel = `${toLocation.country},${toLocation.location} `

          return (
            <TimelineItem
              status={'pending'}
              text={
                <>
                  <span>{`[${route.index} : ${route.type}] Route From ${fromLabel} to ${toLabel}.`}</span>
                  <a onClick={() => onShow(route, 'edit')}>(More Info)</a>
                </>
              }
            />
          )
        })}
      </Timeline>
    </>
  )
}

DeliveryRouteList.propTypes = {}
DeliveryRouteList.defaultProps = {}

export default DeliveryRouteList
